// Условия списка писем в адресе страницы (008: T024; FR-021; contracts/api.md 008,
// GET /api/delivery/messages): поиск по номеру и адресу, статус, вид, сортировка по времени
// и letter — открытая карточка письма справа: /settings/letters?letter=<id> (тост пробного
// письма ведёт сюда). По умолчанию — все письма, новые сверху (-createdAt); значения по умолчанию
// в адрес не пишутся.
import { mailMessageKinds, mailMessageSortFields, mailMessageStates } from '@kp/contracts';
import type { MailMessageKind, MailMessageState, SortValue } from '@kp/contracts';

export type LettersSortField = (typeof mailMessageSortFields)[number];
export type LettersSort = SortValue<LettersSortField>;

export interface LettersSearch {
  q?: string;
  state?: MailMessageState;
  kind?: MailMessageKind;
  sort?: LettersSort;
  /** Открытая карточка письма. */
  letter?: string;
}

export const DEFAULT_LETTERS_SORT: LettersSort = '-createdAt';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const sortValues = mailMessageSortFields.flatMap((field) => [field, `-${field}`]) as LettersSort[];

function oneOf<T extends string>(values: readonly T[], value: unknown): T | undefined {
  return typeof value === 'string' && (values as readonly string[]).includes(value)
    ? (value as T)
    : undefined;
}

/** Для адреса страницы: validateSearch маршрута /settings/letters. */
export function parseLettersSearch(search: Record<string, unknown>): LettersSearch {
  const result: LettersSearch = {};
  if (typeof search.q === 'string' && search.q.trim() !== '') result.q = search.q;
  const state = oneOf(mailMessageStates, search.state);
  if (state) result.state = state;
  const kind = oneOf(mailMessageKinds, search.kind);
  if (kind) result.kind = kind;
  const sort = oneOf(sortValues, search.sort);
  if (sort) result.sort = sort;
  if (typeof search.letter === 'string' && UUID.test(search.letter)) result.letter = search.letter;
  return result;
}

/** Условия сужают список: «Ничего не найдено» вместо «Писем пока нет». */
export function hasLettersFilters(search: LettersSearch): boolean {
  return Boolean(search.q?.trim() || search.state || search.kind);
}

/** Сортировка: «Сортировка: время». */
export const lettersSortLabels = {
  createdAt: 'Время',
} as const satisfies Record<LettersSortField, string>;
